export const queryKeys = {
  budgets: ["budgets"] as const,
  budget: (id: string) => ["budget", id] as const,
  scenarios: ["scenarios"] as const,
  scenario: (id: string) => ["scenario", id] as const,
  events: (type?: string) => (type ? (["events", type] as const) : (["events"] as const)),
  event: (id: string) => ["event", id] as const,
  members: ["members"] as const,
  member: (id: string) => ["member", id] as const,
  contacts: (params: Record<string, unknown>) => ["contacts", params] as const,
  contact: (id: string) => ["contact", id] as const,
  contactTags: ["contacts", "tags"] as const,
  mailingLists: ["mailingLists"] as const,
  mailingList: (id: string) => ["mailingList", id] as const,
  mailingListPreview: (id: string) => ["mailingList", id, "preview"] as const,
  mailingListStats: (id: string) => ["mailingList", id, "stats"] as const,
  mailingListIncluded: (id: string, page: number, limit: number, q?: string) =>
    ["mailingList", id, "included", page, limit, q ?? ""] as const,
  mailingListMembers: (id: string) => ["mailingList", id, "members"] as const,
  mailingListMemberIds: (id: string) => ["mailingList", id, "memberIds"] as const,
  contactMailingLists: (contactId: string) => ["contact", contactId, "mailingLists"] as const,
  mailingBatches: ["mailingBatches"] as const,
  mailingBatch: (id: string) => ["mailingBatch", id] as const,
  qrCodes: ["qrCodes"] as const,
  qrCode: (id: string) => ["qrCode", id] as const,
  meetings: (sort?: string) => (sort ? (["meetings", sort] as const) : (["meetings"] as const)),
  motionsList: (page: number, perPage: number, q?: string) =>
    ["meetings", "motions", page, perPage, q ?? ""] as const,
  meeting: (id: string) => ["meeting", id] as const,
  meetingTemplates: (type?: string) =>
    type ? (["meetingTemplates", type] as const) : (["meetingTemplates"] as const),
  meetingTemplate: (id: string) => ["meetingTemplate", id] as const,
  oldBusiness: ["oldBusiness"] as const,
  committees: (sort?: string) =>
    sort ? (["committees", sort] as const) : (["committees"] as const),
  committee: (id: string) => ["committee", id] as const,
  committeeMeetings: (committeeId: string) => ["committee", committeeId, "meetings"] as const,
  committeeMeeting: (committeeId: string, meetingId: string) =>
    ["committee", committeeId, "meeting", meetingId] as const,
  websitePages: ["website", "pages"] as const,
  websitePage: (id: string) => ["website", "page", id] as const,
  websiteSettings: ["website", "settings"] as const,
  websiteBlogAll: ["website", "blog", "admin"] as const,
} as const;
